import { Alert } from "@mui/material";
import React, { useEffect } from "react";
import { DEFAULT_FRONT_MODE } from "../../utils/frontChannelSettings";

const MODE_OPTIONS = [
  {
    value: "legacy",
    title: "Simple Notifications",
    description:
      "Receive a standard notification with call details and a link to the call for any incoming calls or voicemails received.",
  },
  {
    value: "voice",
    title: "Front Voice Lifecycle Notifications",
    description:
      "A richer notification type that allows for recording and transcription playback directly inside of Front.",
    beta: true,
    requiresTeamPlan: true,
  },
];

const FrontChannelSettings = ({
  frontMode,
  onChange,
  canUseVoiceMode = false,
  planLoaded = false,
  onUpgrade,
}) => {
  useEffect(() => {
    if (planLoaded && !canUseVoiceMode && frontMode === "voice") {
      onChange({ frontMode: DEFAULT_FRONT_MODE });
    }
  }, [planLoaded, canUseVoiceMode, frontMode, onChange]);

  const handleOptionClick = (option) => {
    if (option.requiresTeamPlan && !canUseVoiceMode) {
      onUpgrade?.();
      return;
    }
    onChange({ frontMode: option.value });
  };

  return (
    <div>
      <div className="lg:text-[14px] text-[13px] font-semibold mb-2">
        Notification type
      </div>
      <div className="space-y-2">
        {MODE_OPTIONS.map((option) => {
          const isLocked = option.requiresTeamPlan && !canUseVoiceMode;
          const selected = frontMode === option.value && !isLocked;
          return (
            <button
              key={option.value}
              type="button"
              onClick={() => handleOptionClick(option)}
              className={`w-full text-left rounded-[10px] border-[2px] px-4 py-3 transition-colors ${
                selected
                  ? "border-brand-primary bg-indigo-50/60"
                  : isLocked
                    ? "border-[#E6E7EB] bg-[#F9FAFB] opacity-70 hover:border-[#D1D5DB]"
                    : "border-[#E6E7EB] bg-[#F9FAFB] hover:border-[#D1D5DB]"
              }`}
            >
              <div className="font-semibold lg:text-[14px] text-[13px] text-gray-900 flex items-center gap-2">
                {option.title}
                {option.beta && (
                  <span className="text-[10px] font-medium px-1.5 py-0.5 rounded bg-indigo-100 text-indigo-700">
                    Beta
                  </span>
                )}
                {isLocked && (
                  <span className="text-[10px] font-medium px-1.5 py-0.5 rounded bg-amber-100 text-amber-800">
                    Team Plan
                  </span>
                )}
              </div>
              <div className="text-[12px] text-gray-600 mt-1">
                {option.description}
              </div>
            </button>
          );
        })}
      </div>
      {!canUseVoiceMode && (
        <Alert color="warning" sx={{ mt: 2 }}>
          <div
            className="text-[14px] hover:underline hover:text-blue-600 cursor-pointer"
            onClick={onUpgrade}
          >
            Upgrade to the Team Plan to use Front Voice Lifecycle Notifications
          </div>
        </Alert>
      )}
    </div>
  );
};

export default FrontChannelSettings;
